const regimenesFiscales = [
  {
    //G01	General de Ley Personas Morales	1	1
    id_Cfdi_Regimen_Fiscal: 1,
    Clave: "601",
    Descripcion: "General de Ley Personas Morales",
    Aplica_Personas_Fisicas: false,
    Aplica_Personas_Morales: true,
  },

  {
    //603	Personas Morales con Fines no Lucrativos
    id_Cfdi_Regimen_Fiscal: 2,
    Clave: "603",
    Descripcion: "Personas Morales con Fines no Lucrativos",
    Aplica_Personas_Fisicas: false,
    Aplica_Personas_Morales: true,
  },

  {
    //605	Sueldos y Salarios e Ingresos Asimilados a Salarios
    id_Cfdi_Regimen_Fiscal: 3,
    Clave: "605",
    Descripcion: "Sueldos y Salarios e Ingresos Asimilados a Salarios",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: false,
  },

  {
    id_Cfdi_Regimen_Fiscal: 4,
    Clave: "606",
    Descripcion: "Arrendamiento",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: false,
  },

  {
    id_Cfdi_Regimen_Fiscal: 5,
    Clave: "607",
    Descripcion: "Régimen de Enajenación o Adquisición de Bienes",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: false,
  },

  {
    id_Cfdi_Regimen_Fiscal: 6,
    Clave: "608",
    Descripcion: "Demás ingresos",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: false,
  },

  {
    id_Cfdi_Regimen_Fiscal: 7,
    Clave: "610",
    Descripcion:
      "Residentes en el Extranjero sin Establecimiento Permanente en México",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: true,
  },

  {
    id_Cfdi_Regimen_Fiscal: 8,
    Clave: "611",
    Descripcion: "Ingresos por Dividendos (socios y accionistas)",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: false,
  },

  {
    id_Cfdi_Regimen_Fiscal: 9,
    Clave: "612",
    Descripcion:
      "Personas Físicas con Actividades Empresariales y Profesionales",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: false,
  },

  {
    id_Cfdi_Regimen_Fiscal: 10,
    Clave: "614",
    Descripcion: "Ingresos por intereses",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: false,
  },

  {
    id_Cfdi_Regimen_Fiscal: 11,
    Clave: "615",
    Descripcion: "Régimen de los ingresos por obtención de premios",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: false,
  },

  {
    id_Cfdi_Regimen_Fiscal: 12,
    Clave: "616",
    Descripcion: "Sin obligaciones fiscales",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: false,
  },

  {
    id_Cfdi_Regimen_Fiscal: 13,
    Clave: "620",
    Descripcion:
      "Sociedades Cooperativas de Producción que optan por diferir sus ingresos",
    Aplica_Personas_Fisicas: false,
    Aplica_Personas_Morales: true,
  },

  {
    id_Cfdi_Regimen_Fiscal: 14,
    Clave: "621",
    Descripcion: "Incorporación Fiscal",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: false,
  },

  {
    id_Cfdi_Regimen_Fiscal: 15,
    Clave: "622",
    Descripcion: "Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras",
    Aplica_Personas_Fisicas: false,
    Aplica_Personas_Morales: true,
  },

  {
    id_Cfdi_Regimen_Fiscal: 16,
    Clave: "623",
    Descripcion: "Opcional para Grupos de Sociedades",
    Aplica_Personas_Fisicas: false,
    Aplica_Personas_Morales: true,
  },

  {
    id_Cfdi_Regimen_Fiscal: 17,
    Clave: "624",
    Descripcion: "Coordinados",
    Aplica_Personas_Fisicas: false,
    Aplica_Personas_Morales: true,
  },

  {
    id_Cfdi_Regimen_Fiscal: 18,
    Clave: "625",
    Descripcion:
      "Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: false,
  },

  {
    id_Cfdi_Regimen_Fiscal: 19,
    Clave: "626",
    Descripcion: "Régimen Simplificado de Confianza",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: true,
  },
]

const RegimenesFiscalesPersonasFisicasFn = () => {
  return regimenesFiscales.filter(regimen => regimen.Aplica_Personas_Fisicas)
}

const RegimenesFiscalesPersonasMoralesFn = () => {
  return regimenesFiscales.filter(regimen => regimen.Aplica_Personas_Morales)
}

const GenerarOptionsFn = regimenes => {
  return regimenes.map(regimen => ({
    value: regimen.Clave,
    label: regimen.Clave + " - " + regimen.Descripcion,
  }))
}

const GetOptionsRegimenesFiscalesFn = (rfc, elige = false) => {
  let Options = {}
  if (rfc.length > 12) {
    Options = GenerarOptionsFn(RegimenesFiscalesPersonasFisicasFn())
  } else {
    Options = GenerarOptionsFn(RegimenesFiscalesPersonasMoralesFn())
  }
  if (elige) {
    // Agregar una opción "Elige" al inicio del arreglo
    Options.unshift({
      value: "", // Puedes usar un valor especial que indique que es una selección predeterminada
      label: "Elige ...", // El texto que quieras mostrar en la opción por defecto
    })
  }
  return Options
}

export {
  regimenesFiscales,
  RegimenesFiscalesPersonasFisicasFn,
  RegimenesFiscalesPersonasMoralesFn,
  GenerarOptionsFn,
  GetOptionsRegimenesFiscalesFn,
}
